import type { TranslationTree } from '../../types';

export const layout: TranslationTree = {
  header: {
    menuToggle: 'Ouvrir le menu de navigation',
    settingsTooltip: 'Paramètres',
  },
  sidebar: {
    traceability: 'Vue des outils',
    analytics: 'Analytique',
    ml: 'Intelligence artificielle',
    labelize: 'Étiquetage',
    admin: 'Administration',
    backendConfig: 'Config backend',
    toolRecommender: "Éco-conception d'outil",
    workshop: 'Atelier',
    profile: 'Profil',
    collapse: 'Réduire',
    expand: 'Développer',
    disconnect: 'Déconnexion',
    mobileNavigation: 'Navigation mobile',
    desktopNavigation: 'Navigation bureau',
  },
  quickAccess: {
    traceability: 'Traçabilité',
  },
  avatarMenu: {
    language: 'Langue',
    profile: 'Profil',
    logout: 'Se déconnecter',
    ariaLabel: 'Menu utilisateur',
  },
  footer: {
    exploreLink: 'Découvrir Louis Bélet',
    contactSupport: 'Contact support',
    rights: 'Tous droits réservés.',
  },
};
